import { environment } from "../../environments/environment";
import { getAuthorization } from "../authorizationGateway";
export const BaseURL = environment.api;
export const Gateway = environment.apiGateway;

export const httpClient = {
  get: async (url: string, config: RequestInit = {}, authorization = false) => {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": getAuthorization(),
        ...(config.headers as HeadersInit || {}),
      }
    });

    return response.json();
  },
  post: async (url: string, data: any, config: RequestInit = {}) => {
    const response = await fetch(url, {
      ...config,
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        ...(config.headers as HeadersInit || {})
      }
    });
    return response.json();
  },
  put: async (url: string, data: any, config: RequestInit = {}) => {
    const response = await fetch(url, {
      ...config,
      method: "PUT",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        ...(config.headers as HeadersInit || {}),
      },
    });
    return response.json();
  },
  delete: async (url: string, config: RequestInit = {}) => {
    const response = await fetch(url, { ...config, method: "DELETE" });
    console.log(response);
    return response;
  },
};
